module.exports = __webpack_public_path__ + "img/LogoNew2x.e3bdc02a.png";